<template>
    <div>
        <!--Header Components-->
        <base-header class="mt-4 pb-6" type=""/>
        <b-container fluid class="mt--6">
          <div>
            <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
          </div>
          <b-row>
            <b-col lg="12">
              <div class="card-wrapper">
                <card>
                  <div slot="header" class="mb-0">
                    <b-row>
                      <b-col cols="8">
                          <h3>{{language_terms['SALES_APPROVAL']}}</h3>
                      </b-col>
                    </b-row>
                  </div>
                  <b-row>
                    <b-col md="2" >
                      <base-input :label="language_terms['DATE_FROM']">
                        <flat-picker v-model="filter.date_from" @on-change="onClickSearch()" slot-scope="{focus, blur}" @on-open="focus" @on-close="blur" style="background-color: white;" class="form-control datepicker"/>
                      </base-input>
                    </b-col>
                    <b-col md="2">
                      <base-input :label="language_terms['DATE_TO']">
                        <flat-picker v-model="filter.date_to" @on-change="onClickSearch()" slot-scope="{focus, blur}" @on-open="focus" @on-close="blur" style="background-color: white;" class="form-control datepicker"/>
                      </base-input>
                    </b-col>
                    <b-col md="4" >
                      <base-input :label="language_terms['KEYWORD']" @change="onClickSearch()" v-model="filter.keyword" />
                    </b-col>
                    <b-col md="2">
                      <base-input :label="language_terms['STATUS']">
                        <el-select v-model="filter.status" filterable @change="onClickSearch()">
                          <el-option v-for="option in status_options"
                                    :key="option.value"
                                    :label="option.label"
                                    :value="option.value">
                          </el-option>
                        </el-select>
                      </base-input>
                    </b-col>
                    <b-col md="2">
                    <base-input :label="language_terms['DOCUMENT_TYPE']">
                      <el-select v-model="filter.document_type" filterable @change="onClickSearch()">
                        <el-option v-for="doctype in document_types_option"
                                  :key="doctype.value"
                                  :label="doctype.label"
                                  :value="doctype.value">
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col>
                  </b-row>
                </card> 
              </div>
            </b-col>
          </b-row>
          <b-row v-if="documents.length > 0">
            <b-col lg="12">
              <div class="card-wrapper">
                <card>
                  <div slot="header" class="mb-0">
                    <b-row>
                      <b-col lg="11">
                          <h3>Sales Invoices</h3>
                      </b-col>
                    </b-row>
                  </div>
                  <b-row class="mt--4">
                    <b-col md="12" class="mt-3">
                      <b-table-simple hover responsive>
                        <b-thead head-variant="light">
                                <b-th>
                                  <input class="Checkbox" type="checkbox" value="1" v-model="is_selected" switch @change="selectAll($event)">
                                </b-th>
                                <b-th class="align-middle">{{language_terms['DOC_DATE']}}</b-th>
                                <b-th class="align-middle">{{language_terms['INV_#']}} </b-th>
                                <b-th class="align-middle">{{language_terms['CUSTOMER']}} </b-th>
                                <b-th class="align-middle">{{language_terms['SALESPERSON']}} </b-th>
                                <b-th class="align-middle">{{language_terms['LOCKED_MESSAGE']}} </b-th>
                            </b-thead>
                        <b-tbody>
                            <tr v-for="(invoice, i) in documents" :key="i">
                              <td style="width:30px">
                                <input class="Checkbox" type="checkbox" value="1" v-model="invoice.is_selected" switch @change= "updateSelectedCount(invoice.is_selected)">
                              </td>
                              <td v-on:click="onClickInvoice(invoice)">{{invoice.date}}</td>
                              <td v-on:click="onClickInvoice(invoice)">{{invoice.code}}</td>
                              <td v-on:click="onClickInvoice(invoice)">{{invoice.customer_name}}</td>
                              <td v-on:click="onClickInvoice(invoice)">{{invoice.salesperson_name}}</td>
                              <td v-on:click="onClickInvoice(invoice)">{{invoice.remarks_system}}</td>
                            </tr>
                        </b-tbody>
                        <div class="floating-bar" v-if="filter.status == null && selectedCount > 0">
                              <div class="floating-bar-container" align="center">
                                  <b-button-group>
                                    <b-button class="transparent-btn"  @click="onClickApprove()">
                                        <i class="fas fa-save mr-2 text-info"></i>{{language_terms['APPROVE']}}
                                    </b-button>
                                    <b-button class="transparent-btn"  @click="onClickReject()">
                                        <i class="fas fa-times mr-2 text-warning"></i>{{language_terms['REJECT']}}
                                    </b-button>
                                  </b-button-group>
                              </div>
                            </div>
                            <div class="floating-bar"  v-else-if="selectedCount > 0">
                              <div class="floating-bar-container" align="center">
                                  <b-button-group>
                                    <b-button class="transparent-btn"  @click="onClickUndo()">
                                        <i class="fas fa-arrow-left mr-2 text-success"></i>{{language_terms['UNDO']}}
                                    </b-button>
                                  </b-button-group>
                              </div>
                            </div>
                      </b-table-simple>
                    </b-col>
                  </b-row>                          
                  <!-- <b-row v-if="filter.status == null && selectedCount > 0" class="mt-3">
                        <b-col lg="12">
                            <base-button type="success" @click.native="onClickApprove()" class="mr-4">
                                {{language_terms['APPROVE']}}
                            </base-button>
                            <base-button type="primary" @click.native="onClickReject()" >
                                {{language_terms['REJECT']}}
                            </base-button>
                        </b-col>
                  </b-row>
                  <b-row v-else-if="selectedCount > 0" class="mt-3">
                      <b-col lg="12">
                          <base-button type="success" @click.native="onClickUndo()" class="mr-4">
                              {{language_terms['UNDO']}}
                          </base-button>
                      </b-col>
                  </b-row> -->
                
                </card>
              </div>
            </b-col>
          </b-row>
            <!-- Pop up modal Invoice-->
          <b-modal id="modalInvoice" v-model="modalInvoice" size="xl" centered class="my-modal" hide-footer>
              <template>
                  <div v-if="modalInvoice">
                      <b-row class="align-items-center mt--2">
                          <b-col md="10" fluid class="mt--7">
                              <h3>{{language_terms["INVOICE"]}} {{ invoice.master.code }}</h3>
                              
                          </b-col>
                      </b-row>
                      <b-row>
                          <!-- <b-col md="2">
                              <base-input :label="language_terms['INV_#']" :value="invoice.master.code" disabled></base-input>
                          </b-col> -->
                          <b-col md="2">
                              <base-input :label="language_terms['DATE']" :value="invoice.master.date" disabled></base-input>
                          </b-col>
                          <b-col md="8">
                              <base-input :label="language_terms['CUSTOMER']" :value="invoice.master.customer_name" disabled></base-input>
                          </b-col>
                          <b-col md="2">
                              <base-input :label="language_terms['SALESPERSON']" :value="invoice.master.salesperson_name" disabled></base-input>
                          </b-col>
                          <b-col md="3">
                              <base-input :label="language_terms['CONTACT']" :value="invoice.customer.contact_telephone" disabled></base-input>
                          </b-col>
                          <b-col md="9">
                              <base-input :label="language_terms['EMAIL']" :value="invoice.customer.contact_email" disabled></base-input>
                          </b-col>

                          <b-col md="3">
                              <base-input :label="language_terms['OVERDUE_AMOUNT']" :value="invoice.customer.customer_amount_overdue" disabled></base-input>
                          </b-col>
                          <b-col md="3">
                              <base-input :label="language_terms['AVAILABLE_CREDIT_LIMIT']" :value="invoice.customer.customer_credit_limit_available" disabled></base-input>
                          </b-col>
                          <b-col md="3">
                              <base-input :label="language_terms['CREDIT_LIMIT']" :value="invoice.customer.customer_credit_limit" disabled></base-input>
                          </b-col>
                          <b-col md="3">
                              <base-input :label="language_terms['CREDIT_TERMS']" :value="invoice.customer.customer_credit_term" disabled></base-input>
                          </b-col>

                          <b-col md="12">
                            <base-input :label="language_terms['REASON']">
                            <textarea disabled class="form-control" id="remark_system_cr" :rows="invoice.master.reasons_count" :value="invoice.master.remarks_system_cr"></textarea>
                            </base-input> 
                          </b-col>
                          <b-col lg="12">
                              <base-input label="Remarks"><textarea disabled class="form-control" id="exampleFormControlTextarea1" rows="3" :value="invoice.master.remarks"></textarea>
                              </base-input>
                          </b-col>
                      </b-row>
                      <b-row v-if="invoice.details.rows.length > 0">
                          <b-col cols="12">
                              <v-client-table v-model="invoice.details.rows" :columns="invoice.details.columns" :options="reportOptions"  >
                              </v-client-table>
                          </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <base-button type="success" @click="onClickInvoiceAction('APPROVE', invoice)" class="right" v-if="invoice.master.is_approved == null">
                            Approve
                          </base-button>
                          <base-button type="danger" @click="onClickInvoiceAction('REJECT', invoice)" class="float-right" v-if="invoice.master.is_approved == null">
                            Reject
                          </base-button>
                          <base-button type="danger" @click="onClickInvoiceAction('UNDO', invoice)" class="float-right" v-if="invoice.master.is_approved != null">
                            Undo
                          </base-button>
                        </b-col>
                      </b-row>
                  </div>
              </template>
          </b-modal>          
        </b-container>
    </div>
  </template>
<style>
th.VueTables__sortable {color:rgb(255,255,255);}
td.VueTables__row  {color:black}
.v-data-table /deep/ .sticky-header {position: sticky; top: var(--toolbarHeight);}
.v-data-table /deep/ .v-data-table__wrapper {overflow: unset;}
</style>
<style>
  input.Checkbox {width: 25px; height: 25px;}</style>
<script>
import moment from 'moment'
import { Select, Option, Checkbox } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import Vue from 'vue'

  export default {
    components:{
      Loading,
      [Select.name]: Select,
      [Option.name]: Option,
      flatPicker,
      PaginatedTables
    },
    computed:{
        ...mapState({
          language_terms: state => state.languages.language_terms,
          selected_lang: state => state.languages.selected_langauge,
      }),
    },
    async mounted()
    {
      this.loadingCounter++
      this.onClickSearch()
      this.loadingCounter--
    },

    data(){
      return{
        invoice: [],
        modalInvoice: false,
        reportOptions:{perPage:100, perPageValues:[],stickyHeader:false, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C', hiddenColumns:[],filterable:false},
        selectedCount: 0,
        is_selected: 1,
        selectedInvoice:[],
        loadingCounter:0,
        filter:{
          document_type:'SI',
          keyword:null,
          status:null,
          date_from:null,
          date_to:moment().format("YYYY-MM-DD"),
        },
        documents:[],
        document_types_option:[
        {
          label:"Sales Invoices",
          value:'SI'
        },
        {
          label:"PIRS",
          value:"PIR"
        }
      ],
        status_options:[
          {
            label:"Pending Approval",
            value:null
          },
          {
            label:"Approved",
            value:"1"
          },
          {
            label:"Rejected",
            value:"0"
          },
        ],
      }
    },
  
    methods:{
      async onClickInvoiceAction(action, invoice)
      {
        this.loadingCounter++

        let url = ''
        invoice = invoice.master
        invoice.is_selected = 1

        if (action == 'APPROVE')
        {
          url = apiRoutes['CLIENT_SALES_APPROVAL_APPROVE']
        }
        else if (action == 'REJECT')
        {
          url = apiRoutes['CLIENT_SALES_APPROVAL_REJECT']
        }
        else if (action == 'UNDO')
        {
          url = apiRoutes['CLIENT_SALES_APPROVAL_UNDO']
        }

        if (url != '')
        {
          let payload = {documents:[invoice]}          
          await axios
          .post(url, payload, authHeader())
          .then((response) => 
          {
            if (response.data.code == 1) {
              this.documents = response.data.data
            } 
            else 
            {
              alert('Failed');
            }
          })
          .catch((error) => {
            if (error.response) {
              Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            }
          });

          this.onClickSearch()
        }
        this.loadingCounter--
        this.modalInvoice = false
      },
      async onClickInvoice(invoice)
      {
        let payload = {document_id:invoice.id}
        await axios.post(apiRoutes['CLIENT_RETRIEVE_SALES_INVOICE'],payload, authHeader()).then((response)=>
        {
            if (response.data.code == 1)
            {
                this.invoice = response.data.data
                this.modalInvoice = true
            }
            else
            {
                this.invoice = null;
            }
        }
        )
        .catch((error)=> {
            if(error.response)
            {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            }
        });
      },
      async updateSelectedCount(is_checked)
      {
        if (is_checked)
          this.selectedCount++
        else
          this.selectedCount--
      },
      async selectAll()
      {
        this.selectedCount = 0
        for (let x = 0;x < this.documents.length;x++)
        {
          this.documents[x].is_selected = this.is_selected
          if (this.is_selected)
            this.selectedCount++
        } 
      },
      async onClickSearch()
      {
        this.loadingCounter++

        this.filter.limit = ''
        let payload = this.filter
            
        await axios
        .post(apiRoutes["CLIENT_SALES_APPROVAL_QUICK_SEARCH"], payload, authHeader())
        .then((response) => 
        {
          if (response.data.code == 1) {
            this.documents = response.data.data
            this.selectedCount = this.documents.length
            this.is_selected = 1
          } 
          else 
          {
            alert('Failed');
          }

        })
        .catch((error) => {
          if (error.response) {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          }
        });
        this.loadingCounter--
      },
      
      async onClickApprove()
      {
        this.loadingCounter++
        this.filter.limit = ''
        let payload = {documents:this.documents}

        await axios
        .post(apiRoutes["CLIENT_SALES_APPROVAL_APPROVE"], payload, authHeader())
        .then((response) => 
        {
          if (response.data.code == 1) {
            this.documents = response.data.data
          } 
          else 
          {
            alert('Failed');
          }
        })
        .catch((error) => {
          if (error.response) {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          }
        });
        this.loadingCounter--
      },

      async onClickReject()
      {
        this.loadingCounter++
        this.filter.limit = ''
        let payload = {documents:this.documents}

        await axios
        .post(apiRoutes["CLIENT_SALES_APPROVAL_REJECT"], payload, authHeader())
        .then((response) => 
        {
          if (response.data.code == 1) {
            this.documents = response.data.data
          } 
          else 
          {
            alert('Failed');
          }
        })
        .catch((error) => {
          if (error.response) {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          }
        });
        this.loadingCounter--
      },

      async onClickUndo()
      {
        this.loadingCounter++
        this.filter.limit = ''
        let payload = {documents:this.documents}
        
        await axios
        .post(apiRoutes["CLIENT_SALES_APPROVAL_UNDO"], payload, authHeader())
        .then((response) => 
        {
          if (response.data.code == 1) {
            this.documents = response.data.data
          } 
          else 
          {
            alert('Failed');
          }
        })
        .catch((error) => {
          if (error.response) {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          }
        });
        this.loadingCounter--
      },
    }
  }
  </script>
  